import {
  ChakraProvider,
  Box,
  Stack,
  Text,
  Heading,
  SimpleGrid,
  Spinner,
} from "@chakra-ui/react";
import { Coach } from "../components/Coaches/CoachCard";
import Carlota from "../images/coaches/carlota_provenzali.webp";
//import Marta from "../images/coaches/marta_daviu.webp";
//import Maria from "../images/coaches/maria_portalo.webp";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function About() {
  const [coaches, setCoaches] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const { data } = await axios.get("/api/coaches");
      const allCoaches = [
        ...data,
        {
          id: 0,
          coachName: "Carlota Provenzali",
          titleKey: "coaches.carlota.title",
          descriptionKey: "coaches.carlota.description",
          avatar: Carlota,
          link: "https://www.instagram.com/carlota_nutri/",
          tagsKey: "coaches.carlota.tags",
        },
      ];
      setCoaches(allCoaches);
    })();
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("about.metaTitle")}</title>
        <meta
          name="description"
          content={t("about.metaDescription")}
        />
      </Helmet>
      <ChakraProvider>
        <Box pt={"20px"} pb={8} textAlign="justify" margin={"auto"}>
          <Heading
            fontFamily={"Oswald"}
            fontWeight={400}
            fontSize={{ base: "4xl", sm: "4xl", md: "5xl" }}
            lineHeight={"110%"}
            color={"gray.800"}
            p={6}
            mb={4}
            textAlign={"center"}
          >
            {t("about.headingPrefix")}
            <Text as={"span"} color={"blue.500"}>
              {" "}
              {t("about.headingEmphasis")}
            </Text>
          </Heading>
          <Box
            textAlign="justify"
            margin={"auto"}
            width="80%"
            maxWidth={"1100px"}
          >
            <Text>
              {t("about.paragraphs.intro")}
            </Text>
            <Text mt={8}>
              {t("about.paragraphs.teamIntro")}
            </Text>

            {coaches ? (
              <SimpleGrid
                columns={{ sm: 1, md: 2, lg: 2, xl: 3 }}
                m="auto"
                mt={5}
              >
                {coaches.map((coach) => (
                  <Coach
                    key={coach.id}
                    coachName={coach.coachName}
                    coachTitle={
                      coach.titleKey ? t(coach.titleKey) : coach.title
                    }
                    coachDescription={
                      coach.descriptionKey
                        ? t(coach.descriptionKey)
                        : coach.description
                    }
                    coachImage={coach.avatar}
                    coachLink={coach.link}
                    coachTrainings={coach.tagsKey ? t(coach.tagsKey) : coach.tags}
                    about={true}
                  />
                ))}
              </SimpleGrid>
            ) : (
              <Stack alignItems="center" my={3}>
                <Spinner size="xl" m={10} />
              </Stack>
            )}
          </Box>
        </Box>
      </ChakraProvider>
    </>
  );
}

export default About;
